import './Loading.style.scss';
import { CircularProgress } from '@mui/material';

export default function Loading(): JSX.Element {
	return (
		<div className="LoadingBox">
			<CircularProgress size={50} />
		</div>
	);
}
